var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQualifies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 12C2.25 6.62211 6.62211 2.25 12 2.25C17.3779 2.25 21.75 6.62211 21.75 12C21.75 17.3779 17.3779 21.75 12 21.75C6.62211 21.75 2.25 17.3779 2.25 12ZM10.6801 16.3479C10.3776 16.3479 10.0751 16.2365 9.83632 15.9976L6.65213 12.8134C6.19042 12.3517 6.19042 11.5875 6.65213 11.1258C7.11383 10.6641 7.87804 10.6641 8.33975 11.1258L10.6801 13.4662L16.2047 7.94164C16.6664 7.47993 17.4306 7.47993 17.8923 7.94164C18.354 8.40335 18.354 9.16755 17.8923 9.62926L11.5239 15.9976C11.2851 16.2365 10.9826 16.3479 10.6801 16.3479Z",
    fill: "#50C887"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualifies);
export default __webpack_public_path__ + "static/media/qualifies.61936b709911f103bbfeb7950a52cd83.svg";
export { ForwardRef as ReactComponent };